<template>
  <v-dialog v-model="isOpen" max-width="500px" persistent>
    <v-card class="pa-4">
      <v-card-title class="headline text-orange-darken-2 pb-2">
        <div class="d-flex align-center">
          <v-icon left class="mr-2" color="#1D1B59">fas fa-clone</v-icon>
          {{ $t("views.trips.create_trip.replicate_trip_title") }}
        </div>
        <v-btn icon @click="closeModal" class="ml-auto">
          <v-icon color="#1D1B59">fas fa-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mb-4" />
      <v-card-text>
        <v-text-field v-model.number="times" type="number" :label="$t('views.trips.create_trip.replicate_trip_label')"
          :rules="[rules.required, rules.min]" outlined dense min="1" max="50" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-row no-gutters align="center" justify="end" class="w-100">
          <v-col cols="auto">
            <v-progress-circular v-if="isLoading" indeterminate color="orange darken-2" size="24" width="2"
              class="mr-3" />
          </v-col>
          <v-col cols="auto">
            <v-btn color="grey" text @click="closeModal">
              {{ $t("views.trips.create_trip.cancel") }}
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn color="orange darken-2" @click="confirm" style="color: white">
              {{ $t("views.trips.create_trip.confirm") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

    </v-card>
    <transition name="fade">
      <v-alert v-if="showSuccessAlert" type="success" elevation="10" class="success-alert" border="left" colored-border>
        {{ $t("views.trips.create_trip.success_message_replicate") }}
      </v-alert>
    </transition>
    <transition name="fade">
      <v-alert v-if="showErrorAlert" type="warning" elevation="10" class="success-alert" border="left" colored-border>
        {{ $t("views.trips.create_trip.replicate_trip_max_limit") }}
      </v-alert>
    </transition>
    <transition name="fade">
      <v-alert v-if="showNotFillAlert" type="warning" elevation="10" class="success-alert" border="left" colored-border>
        {{ $t("views.trips.create_trip.not_filled") }}
      </v-alert>
    </transition>
  </v-dialog>
</template>

<script>
import { buildManualTripPayload } from "@/components/views/Trip/Create/buildManualTripPayload";
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    idCompanyParent: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      isLoading: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      showNotFillAlert: false,
      times: null,
      rules: {
        required: value => !!value || "Este campo es requerido.",
        min: value => value >= 1 || "Debe ser al menos 1.",
        max: value => value <= 50 || "El máximo permitido es 50.",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async confirm() {
      if (!this.times || this.times < 1 || this.times > 50) {
        this.showErrorAlert = true;
        setTimeout(() => {
          this.showErrorAlert = false;
        }, 3000);
        return;
      }
      const { type_operation, code_type_operation, code_type_trip } = this.formData;
      if (!type_operation || !code_type_operation || !code_type_trip) {
        this.showNotFillAlert = true;
        setTimeout(() => {
          this.showNotFillAlert = false;
        }, 3000);
        return;
      }
      this.isLoading = true;
      try {
        this.showSuccessAlert = true;
        setTimeout(() => {
          this.showSuccessAlert = false;
        }, 3000);
        const response = await this.axios.post(
          `/Travels/CreateMultipleManualTrip?numberRepetitions=${this.times}`,
          buildManualTripPayload(this.formData)
        );
        setTimeout(() => {
          this.$emit("close");
        }, 100);
        window.location.reload();
        this.$notify?.({
          type: "success",
          text: `Se replicaron ${this.times} viajes correctamente.`,
        });

      } catch (error) {
        console.error("Error al replicar viajes:", error);
        this.showErrorAlert = true;
        setTimeout(() => {
          this.showErrorAlert = false;
        }, 3000);
      } finally {
        this.isLoading = false;
      }


    }
  }
};
</script>
<style lang="scss" scoped src="../TripCreateForm.module.scss" />